export const HighlightTeaserGroupWidgetId = 'HighlightTeaserGroupWidget';

export enum HighlightTeaserGroupWidgetAttributes {
  ELEMENT_ID = 'elementId',
  HIGHLIGHT_TEASER = 'highlightTeaser',
}
